$(document).ready(function(){

    mapInit([], [], 'objects-map-init'); //RECardDescription-Map

    validateForm({
        formId: 'form-live'
        //formValidClass: 'Form_valid',
        //formInvalidClass: 'Form_invalid',
        //inputErrorClass: 'Input_error'
    });
});